import React from 'react';
import './Careers.css';

const Careers = () => {

  const benefits = [
    {
      icon: "💰",
      title: "Lương thưởng hấp dẫn",
      description: "Chế độ lương thưởng cạnh tranh, đánh giá hiệu quả công việc định kỳ"
    },
    {
      icon: "🏥",
      title: "Bảo hiểm đầy đủ",
      description: "Bảo hiểm xã hội, y tế, thất nghiệp theo quy định và bảo hiểm bổ sung"
    },
    {
      icon: "📚",
      title: "Đào tạo phát triển",
      description: "Chương trình đào tạo nâng cao chuyên môn và kỹ năng mềm"
    },
    {
      icon: "🌴",
      title: "Nghỉ phép linh hoạt",
      description: "Chế độ nghỉ phép năm, nghỉ lễ tết và các hoạt động team building"
    },
    {
      icon: "🚀",
      title: "Cơ hội thăng tiến",
      description: "Lộ trình thăng tiến rõ ràng, cơ hội phát triển sự nghiệp lâu dài"
    },
    {
      icon: "🏢",
      title: "Môi trường chuyên nghiệp",
      description: "Văn hóa công ty tích cực, đồng nghiệp thân thiện và hỗ trợ"
    }
  ];

  const workCulture = [
    {
      title: "Đổi mới sáng tạo",
      description: "Khuyến khích nhân viên đưa ra ý tưởng mới và cải tiến quy trình làm việc"
    },
    {
      title: "Học hỏi không ngừng",
      description: "Tạo điều kiện cho nhân viên học tập, nâng cao trình độ chuyên môn"
    },
    {
      title: "Làm việc nhóm",
      description: "Tinh thần đoàn kết, hợp tác để đạt được mục tiêu chung"
    },
    {
      title: "Chất lượng cao",
      description: "Cam kết mang đến sản phẩm và dịch vụ chất lượng cao nhất"
    }
  ];

  return (
    <div className="careers-page">
      <div className="container">
        {/* Page Header */}
        <section className="page-header">
          <h1>Tuyển dụng</h1>
          <p>Gia nhập đội ngũ DSC.JSC - Nơi phát triển sự nghiệp của bạn</p>
        </section>

        {/* Why Join Us */}
        <section className="why-join-us">
          <h2>Tại sao chọn DSC.JSC?</h2>
          <div className="benefits-grid">
            {benefits.map((benefit, index) => (
              <div key={index} className="benefit-card">
                <div className="benefit-icon">{benefit.icon}</div>
                <h3>{benefit.title}</h3>
                <p>{benefit.description}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Work Culture */}
        <section className="work-culture">
          <h2>Văn hóa công ty</h2>
          <div className="culture-grid">
            {workCulture.map((item, index) => (
              <div key={index} className="culture-item">
                <h4>{item.title}</h4>
                <p>{item.description}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Application Process */}
        <section className="application-process">
          <h2>Quy trình tuyển dụng</h2>
          <div className="process-steps">
            <div className="step">
              <div className="step-number">1</div>
              <h4>Nộp hồ sơ</h4>
              <p>Gửi CV và thư xin việc qua email hoặc form online</p>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <h4>Sàng lọc hồ sơ</h4>
              <p>HR sẽ xem xét và liên hệ với ứng viên phù hợp</p>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <h4>Phỏng vấn</h4>
              <p>Phỏng vấn trực tiếp với trưởng bộ phận và HR</p>
            </div>
            <div className="step">
              <div className="step-number">4</div>
              <h4>Thông báo kết quả</h4>
              <p>Thông báo kết quả và thỏa thuận điều kiện làm việc</p>
            </div>
          </div>
        </section>

        {/* Contact HR */}
        <section className="contact-hr">
          <div className="hr-content">
            <h2>Liên hệ tuyển dụng</h2>
            <p>Bạn có câu hỏi về vị trí tuyển dụng? Hãy liên hệ với chúng tôi!</p>
            <div className="hr-info">
              <div className="hr-item">
                <strong>📧 Email:</strong> mienbacdsc@gmail.com
              </div>
              <div className="hr-item">
                <strong>📞 Hotline:</strong> 02253920691
              </div>
              <div className="hr-item">
                <strong>🕒 Thời gian:</strong> T2-T6: 8:00-17:00
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Careers;